import Grid2 from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useUserContext } from "@dexteel/mesf-core";
import { EndFilter, SearchFilter, StartFilter } from "./";
import { ExpiredFilter } from "./ExpiredFilter";
import { StatusFilter } from "./StatusFilter";
import { cmmsTheme } from "@setup/theme/cmms-theme";

export const Filters = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const resetFilter = () => {
		setSearchParams(new URLSearchParams(), { replace: true });
		setTimeout(() => {
			navigate(`/forms/`, { replace: true });
		}, 50);
	};

	return (
		<Grid2 container alignItems="flex-end" spacing={1}>
			<Grid2 size={{ lg: 2, md: 6, xs: 12 }}>
				<StartFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 6, xs: 12 }}>
				<EndFilter />
			</Grid2>
			<Grid2 size={{ lg: 3, md: 6, xs: 12 }}>
				<SearchFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 6, xs: 12 }}>
				<StatusFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 6, xs: 12 }}>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						height: cmmsTheme.dimensions.standardInput,
						marginTop: "8px",
						marginBottom: "4px",
					}}
				>
					<ExpiredFilter />
				</Box>
			</Grid2>
			<Grid2 size={{ lg: 1, md: 6, xs: 12 }}>
				<Box sx={{ marginTop: "8px", marginBottom: "4px" }}>
					<Button
						fullWidth
						variant="contained"
						color="inherit"
						onClick={resetFilter}
						sx={{ height: cmmsTheme.dimensions.standardInput }}
					>
						RESET
					</Button>
				</Box>
			</Grid2>
		</Grid2>
	);
};
